import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import CharacterBuilderClassNew from './CharacterBuilderClassNew.vue';
import CharacterBuilderClassHitPoints from './CharacterBuilderClassHitPoints.vue';
import CharacterBuilderClass from './CharacterBuilderClass.vue';
import MySelect from '@/components/MySelect.vue';
const characterAdvancementsModule = namespace('characterAdvancements');
let CharacterBuilderClasses = class CharacterBuilderClasses extends Vue {
    created() {
        this.fetchCharacterAdvancements();
    }
    get currentClasses() {
        return this.character.classes;
    }
    get isFixedHitPoints() {
        return this.character.settings.isFixedHitPoints;
    }
    get currentLevel() {
        return this.currentClasses.reduce((acc, { levels }) => acc + levels, 0);
    }
    handleAddClass(name) {
        const position = this.currentClasses.length;
        const newClassData = this.classes.find(({ name: className }) => name === className);
        if (!newClassData)
            console.error('Class not found: ', name);
        const amount = newClassData ? newClassData.hitPointsAtHigherLevelsNumber : 0;
        const advancement = this.characterAdvancements.find(({ level }) => level === this.currentLevel + 1);
        const experiencePoints = advancement ? advancement.experiencePoints : this.character.experiencePoints;
        this.$emit('updateCharacter', {
            classes: {
                [position]: {
                    name,
                    levels: 1,
                    hitPoints: position === 0 ? [] : [amount],
                    abilityScoreImprovements: []
                }
            },
            experiencePoints
        });
    }
    getClassTitle(myClass) {
        const archetype = myClass.archetype ? ` (${myClass.archetype.name})` : '';
        return myClass.name + archetype + ' ' + myClass.levels;
    }
};
__decorate([
    Prop(Object)
], CharacterBuilderClasses.prototype, "character", void 0);
__decorate([
    Prop(Array)
], CharacterBuilderClasses.prototype, "classes", void 0);
__decorate([
    Prop(Array)
], CharacterBuilderClasses.prototype, "features", void 0);
__decorate([
    characterAdvancementsModule.State
], CharacterBuilderClasses.prototype, "characterAdvancements", void 0);
__decorate([
    characterAdvancementsModule.Action
], CharacterBuilderClasses.prototype, "fetchCharacterAdvancements", void 0);
CharacterBuilderClasses = __decorate([
    Component({
        components: {
            CharacterBuilderClass,
            CharacterBuilderClassNew,
            CharacterBuilderClassHitPoints,
            MySelect
        }
    })
], CharacterBuilderClasses);
export default CharacterBuilderClasses;
